import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { floor } from 'lodash';
import { FormattedMessage } from 'react-intl';

import Paper from 'material-ui/Paper';
import TextField from 'material-ui/TextField';
import FlatButton from 'material-ui/FlatButton';
import FontIcon from 'material-ui/FontIcon';
import IconButton from 'material-ui/IconButton';
import Toggle from 'material-ui/Toggle';
import { Col, Row } from 'react-flexbox-grid';
import { List, ListItem } from 'material-ui/List';
// import Avatar from 'material-ui/Avatar';
import LinearProgress from 'material-ui/LinearProgress';
import ReactList from 'react-list';
import debounce from 'lodash/throttle';

import * as actionCreators from 'actions/EmployeeSearch';
import styles from 'styles/EmployeeSearch';
import EmployeeSearchDialog from './EmployeeSearchDialog';
import KAvatar from '../components/KJRN/KAvatar';

const FM = ({ id }) => <div><FormattedMessage id={`employeeSearch.${id}`} /></div>;
FM.propTypes = { id: PropTypes.string.isRequired };

const EmployeeSearch = (props) => {
  const {
    loaded, resultData, error, valuesByKey,
  } = props;
  const query = props.location.query.query;

  const [inputValue, setInputValue] = useState(query || '');
  const [dialogContent, setDialogContent] = useState(null);
  // const [hideProfile, setHideProfile] = useState({});
  const [searchByQualification, setSearchByQualification] = useState(false);

  const search = debounce((q) => {
    const qualificationTypes = (valuesByKey['Show.QualificationSearch.Type'] && valuesByKey['Show.QualificationSearch.Type'].Value) ?
      valuesByKey['Show.QualificationSearch.Type'].Value : '';
    if (searchByQualification) {
      props.actions.fetchByQualification(q, qualificationTypes);
    } else {
      props.actions.fetch(q);
    }
  }, 500);

  const handleDialogClose = () => {
    setDialogContent(null);
  };

  const onKeyPress = (event) => {
    if (event.keyCode === 27) {
      handleDialogClose();
    }
  };

  useEffect(() => {
    if (query) search(query);
    window.addEventListener('keydown', onKeyPress);
    return () => {
      window.removeEventListener('keydown', onKeyPress);
    };
  }, [query]);

  const onClickSearch = (q) => {
    setSearchByQualification(false);
    handleDialogClose();
    search(q);
    setInputValue(q);
  };

  const handleChange = ev => setInputValue(ev.target.value);

  const toggleQualificationSearch = (ev, val) => {
    setSearchByQualification(val);
    props.actions.requestSearchClear();
  };

  const keyDownText = (ev) => {
    if (ev.keyCode === 13) {
      const { value } = ev.target;
      setInputValue(value);
      search(value);
    }
  };

  // const handleError = (index) => {
  //   setHideProfile({ ...hideProfile, [index]: true });
  // };

  const handleDialogOpen = (index) => {
    setDialogContent(props.resultData[index]);
  };

  const renderRow = (index) => {
    const {
      ImageUrl, Name, Department, Title, Qualifications, EmployeeDetailID,
    } = props.resultData[index];
    const queryQualifications = Qualifications && Qualifications.filter(q => q.Qualification && q.Qualification.toLowerCase().includes(props.query.toLowerCase()));
    return (
      <ListItem
        key={EmployeeDetailID}
        leftAvatar={
          <KAvatar
            imgSrc={ImageUrl}
            style={styles.avatar}
            masterId={floor(EmployeeDetailID / 10, 0)}
            size={40}
          />
        }
        primaryText={Name}
        secondaryText={
          <div style={{ height: '100%' }}>
            <p style={styles.secondaryText}>{`${Title}, ${Department}`}</p>
            {searchByQualification && queryQualifications.length > 0 &&
              <div
                style={{
                  marginLeft: -4,
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis',
                }}
              >
                <FontIcon className="material-icons" style={styles.secondaryText}>flag</FontIcon>
                <p style={styles.secondaryText}>
                  {queryQualifications.map(q => q.Qualification).join(', ')}
                </p>
              </div>
            }
          </div>}
        onClick={() => handleDialogOpen(index)}
      />
    );
  };

  return (
    <Col xs={12} md={8} lg={6} mdOffset={2} lgOffset={3} >
      {dialogContent &&
        <EmployeeSearchDialog
          dialogOpen={Boolean(dialogContent)}
          dialogContent={dialogContent}
          inputValue={inputValue}
          handleDialogClose={handleDialogClose}
          onClickSearch={onClickSearch}
        />
      }
      <Paper style={{ marginTop: 16 }}>
        <Row middle="xs" style={{ paddingRight: 16, paddingLeft: 16 }}>
          <Col xs>
            <TextField
              hintText={<FormattedMessage id="employeeSearch.placeholder" />}
              style={styles.root}
              underlineShow={false}
              onChange={handleChange}
              onKeyDown={keyDownText}
              autoComplete="off"
              autoCorrect="off"
              autoCapitalize="off"
              spellCheck="false"
              value={inputValue}
            />
          </Col>
          <Col>
            <FlatButton
              primary
              label={<FormattedMessage id="employeeSearch.button" />}
              labelPosition="before"
              onClick={() => search(inputValue)}
              icon={
                <FontIcon className="material-icons">search</FontIcon>
              }
            />
          </Col>
        </Row>
        {!loaded && <LinearProgress mode="indeterminate" />}
      </Paper>
      {(valuesByKey['Show.QualificationSearch'] && valuesByKey['Show.QualificationSearch'].Value === 'true') &&
        <Row end="xs" style={{ margin: 8 }}>
          <Col xs={11} md={8}>
            <Toggle
              onToggle={toggleQualificationSearch}
              toggled={searchByQualification}
              label={<FormattedMessage id="employeeSearch.qualificationToggle" />}
            />
          </Col>
          {valuesByKey['Info.QualificationSearch'] &&
            <Col xs={1}>
              <IconButton
                iconClassName="material-icons"
                style={styles.infoButton}
                tooltipPosition="bottom-left"
                tooltip={<div style={styles.infoList}>{valuesByKey['Info.QualificationSearch'].Value.split`;`.map((x, key) => <span key={key}>{x}</span>)}</div>}
              >
                info_outline
              </IconButton>
            </Col>}
        </Row>
      }
      {loaded && !resultData.length && inputValue && <div style={styles.message}><FormattedMessage id="employeeSearch.noresult" /></div>}
      {error && <div style={styles.errorMessage}>{`Villa við leit: ${error.Message || error.message}`}</div>}
      {resultData.length > 0 &&
        <Paper style={styles.result}>
          <List style={{ overflow: 'auto', height: 'calc(100vh - 275px)' }}>
            <ReactList
              itemRenderer={renderRow}
              length={props.resultData.length}
              useStaticSize
              // type="variable"
            />
          </List>
        </Paper>
      }
    </Col>
  );
};

EmployeeSearch.propTypes = {
  loaded: PropTypes.bool,
  resultData: PropTypes.array,
  actions: PropTypes.object,
  location: PropTypes.object,
  error: PropTypes.object,
  valuesByKey: PropTypes.object,
  query: PropTypes.string,
};

export default connect(
  state => ({ ...state.EmployeeSearch, valuesByKey: state.WebValuesReducer.valuesByKey }),
  dispatch => ({ actions: bindActionCreators(actionCreators, dispatch) }),
)(EmployeeSearch);



// WEBPACK FOOTER //
// ./src/containers/EmployeeSearch.js